import { ArtistProfileTemplate } from '../../api/public';

const COVER_PLACEHOLDER = 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)';

export const PRIMARY_BUTTON_HOVER_COLOR = '#FECE2E';

// Gradient uses near-black values matching the dark theme; can't use sx tokens in CSS gradient strings
export const CARD_GRADIENT_BACKGROUND =
  'linear-gradient(0deg, #0C0C0C 38%, #212121 100%)';

export const CARD_BOX_SHADOW = 1;

export const ARTIST_PROFILE_BASE_URL =
  'https://klydo-clock.myshopify.com/pages/artist-profile';

export const getCoverBackground = (
  coverUrl: string | undefined,
  dominantColor: string | null | undefined,
  backgroundDefault: string,
): string | undefined => {
  if (coverUrl) return undefined;
  if (dominantColor)
    return `linear-gradient(to bottom, ${dominantColor} 0%, ${backgroundDefault} 100%)`;
  return COVER_PLACEHOLDER;
};

export const getSectionTitle = (
  type: string,
  templates: ArtistProfileTemplate[],
) => {
  const matchedTemplate = templates.find(
    (profileTemplate) => profileTemplate.key === type,
  );
  return matchedTemplate?.name ?? type;
};

export const COVER_ASPECT_RATIO = '7 / 2';

export const COVER_CONTENT_OVERLAP = '50px';

export const COVER_UPLOAD_HINT = '7:2 | PNG, JPG — Max 10MB';
